import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

export default function withBulmaModalLayout(WrappedComponent) {
  return class BulmaModalLayout extends React.Component {
    static propTypes = {
      isOpen: PropTypes.bool,
      onRequestClose: PropTypes.func.isRequired,
      params: PropTypes.object.isRequired
    }

    handleRequestClose = () => {
      if (this.props.onRequestClose) {
        this.props.onRequestClose(null)
      }
    }

    render() {
      const { isOpen = true } = this.props

      return (
        <div className={classnames('modal', { 'is-active': isOpen })}>
          <div className="modal-background" onClick={this.handleRequestClose} />
          <div className="modal-content">
            <WrappedComponent {...this.props} />
          </div>
          <button
            className="modal-close is-large"
            aria-label="close"
            onClick={this.handleRequestClose}
          />
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/modal/withBulmalModalLayout.js